import React, { useEffect, useState } from "react";
import { Form, Drawer, Select, Button, Alert, Divider } from "antd";

import SurgicalInterventionSummary from "../surgical_intervention/SurgicalInterventionSummary";
import CapacityDatePicker from "../../components/CapacityDatePicker";

import moment from "moment";
import { reScheduleReasons } from "../../constants";
import { defineExpectedEndAt } from "../../core/surgicalIntervention";

import { getOne as GetSurgicalProcedure } from "../../api/SurgicalProcedure";
import { all as AllCarePlan } from "../../api/CarePlan";

const { Option } = Select;

const layout = {
  labelCol: {
    span: 7,
  },
  wrapperCol: {
    span: 16,
    className: "mx-3",
  },
};

const layoutSelect = {
  showSearch: true,
  allowClear: true,
  optionFilterProp: "children",
};

const SurgicalInterventionRescheduleForm = (props) => {
  const { surgicalIntervention } = props;
  const [form] = Form.useForm();
  const [surgicalProcedure, setSurgicalProcedure] = useState(null);
  const [carePlans, setCarePlans] = useState([]);
  const [editable, setEditable] = useState(false);

  /**
   * 
   * @param {*} start_at 
   * @param {*} expected_end_at 
   * @returns 
   */
  const isEditable = (start_at, expected_end_at) => {
    for(let i in carePlans) {
      let carePlan = carePlans[i];
      let actionTime = moment(carePlan['action_time']);

      if (actionTime < start_at || actionTime > expected_end_at) {
        setEditable(false);
        return;
      }
    }
    setEditable(true);
  }

  const onFinish = async () => {
    form
      .validateFields()
      .then(async (values) => {
        props.onUpdate(surgicalIntervention.id, values['reason_id'], values['start_at'], values['expected_end_at']);
        onClose();
      })
      .catch((errors) => {
        return;
      });
  };

  const fetchCarePlans = async function (surgicalInterventionId) {
    AllCarePlan({
      current: 1,
      pageSize: 100,
      sort: "action_time,1",
      q: {
        "surgical_intervention_id": surgicalInterventionId,
      },
    })
      .then((data) => {
        setCarePlans(data.results);
      });
  };

  /**
   *
   * @param {*} search
   */
  const fetchSurgicalProcedure = async function (surgicalProcedureId) {
    GetSurgicalProcedure(surgicalProcedureId).then((data) => {
      setSurgicalProcedure(data);
    });
  };

  const onClose = () => {
    props.onClose();
    form.resetFields();
  };

  /**
   *
   * @param {*} startAt
   */
  const onChangeStartAtHandler = (startAt) => {
    if (startAt !== null) {
      let expectedEndAt = defineExpectedEndAt(
        startAt,
        surgicalProcedure.duration_of_stay
      );
      form.setFieldsValue({
        expected_end_at: expectedEndAt,
      });

      isEditable(startAt, expectedEndAt);
    }
  };

  /**
   *
   * @param {*} startAt
   */
  const onChangeExpectedEndAtHandler = (expectedEndAt) => {
    if (expectedEndAt !== null) {
      isEditable(form.getFieldValue('start_at'), expectedEndAt);
    }
  };

  useEffect(() => {
    if (surgicalIntervention) {
      const fetchData = async () => {
        await fetchCarePlans(surgicalIntervention.id);
        await fetchSurgicalProcedure(surgicalIntervention.surgical_procedure_id);

        form.setFieldsValue({
          reason_id: 1,
          start_at: moment(surgicalIntervention.start_at),
          expected_end_at: moment(surgicalIntervention.expected_end_at),
        });

        isEditable(surgicalIntervention.start_at, surgicalIntervention.expected_end_at)
      }

      fetchData();
    }
  }, [surgicalIntervention]);

  let reScheduleReasonsOptions = reScheduleReasons.map((option, index) => (
    <Option key={index} value={option.id}>
      {option.label}
    </Option>
  ));

  if (!surgicalIntervention) {
    return null;
  }

  let warning = null;
  if (!editable) {
    warning = (
      <Alert
        message="Modification impossible"
        description="Des soins ont déjà été saisis sur des jours non inclus dans la nouvelle plage de dates."
        type="warning"
        showIcon
        style={{
          "marginBottom": "20px"
        }}
      />
    )
  }

  return (
    <Drawer
      width={800}
      title="Modification des dates"
      placement="left"
      visible={props.visible}
      onClose={onClose}
      footer={
        <div style={{ textAlign: "right" }}>
          <div>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Annuler
            </Button>
            <Button onClick={onFinish} type="primary" disabled={!editable}>
              Enregistrer
            </Button>
          </div>
        </div>
      }
    >
      <SurgicalInterventionSummary surgicalIntervention={surgicalIntervention} />
      <Divider />
      {warning}
      <Form {...layout} form={form} className="my-2">
        <Form.Item label="Raison de la modification" name="reason_id">
          <Select {...layoutSelect} allowClear={false}>
            {reScheduleReasonsOptions}
          </Select>
        </Form.Item>
        <Form.Item
          label="Date d'entrée"
          name="start_at"
          rules={[{ required: true }]}
        >
          <CapacityDatePicker
            format="DD/MM/YYYY"
            allowClear={false}
            onChange={onChangeStartAtHandler}
            careUnitId={surgicalIntervention.care_unit_id}
          />
        </Form.Item>
        <Form.Item
          label="Date de sortie estimée"
          name="expected_end_at"
          rules={[{ required: true }]}
        >
          <CapacityDatePicker
            format="DD/MM/YYYY"
            allowClear={false}
            onChange={onChangeExpectedEndAtHandler}
            careUnitId={surgicalIntervention.care_unit_id}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default SurgicalInterventionRescheduleForm;
